import { IsTest } from "@/utils/tools";
import { request } from "..";

// TODO 请求域名确定
const testOrigin = "https://test-sg-act.playerinfinite.com/";
const prodOrigin = "https://sg-act.playerinfinite.com/";
const origin = IsTest ? testOrigin : prodOrigin;
interface commomRes {
  code: number;
  msg: string;
  data?: any;
}

interface GetVertifyCodReq {
  game_id: string;
  phone: string;
}

interface GetVertifyCodRes extends commomRes {
  data: {
    lock_time: number;
    expire_time: number;
  };
}
export const getVertifyCod = async (params: GetVertifyCodReq) => {
  const url = "api/proxy_direct/account/Phone/SendPhoneCode";
  return request
    .post<GetVertifyCodRes>(`${origin}${url}`, {
      ...params,
      checkLogin:false,
      needLogin: false,
    })
    .then((res) => res.data);
};

export interface LoginReq {
  game_id: string;
  phone: number;
  auth_code: number;
  privacyAgree?: boolean;
  above18Agree?: boolean;
}

export interface LoginRes extends commomRes {
  data: {
    result: number;
    errmsg: string;
    user_id: string;
    ct: string;
    is_new_user: 0 | 1;
    expires: number;
    refresh_ct_span: number;
    wt: string;
    ctt: string;
    sk: string;
    refresh_wt_span: number;
  };
}
export const login = async (params: LoginReq) => {
  const testOrigin = "https://t-sg-community.playerinfinite.com/";
  const prodOrigin = "https://sg-community.playerinfinite.com/";
  const origin = IsTest ? testOrigin : prodOrigin;
  const url = "api/gpts.auth_svr.AuthSvr/LoginByPhoneAuthCode";
  return request
    .post<LoginRes>(`${origin}${url}`, {
      ...params,
      clienttype: 903,
      intl_source: "32",
      checkLogin:false,
      needLogin: false,
    })
    .then((res) => res.data);
};

/**
 * 一共4个接口：
1.发送验证码，参数是手机号，返回下次可以发送时间
2.验证码登陆，参数手机号+验证码，返回登陆态，前端写cookie （uid,gameid,wt）这三个参数+ account_type:101 一共4个参数是登陆态，请求接口 url带着
3.初始化接口（未预约的情况下 预约），返回本人已经邀请人数+分享码
4.提交分享码接口
 */

interface GetShareCodeRes extends commomRes {
  data: {
    share_code: string;
    share_num: number;
  };
}
// @see https://yapi.intlgame.com/project/1344/interface/api/79536
export const getShareCode = async () => {
  const url = "api/flow/Wand-20230508085654-F49bb365e0824";
  return request
    .post<GetShareCodeRes>(`${origin}${url}`, {})
    .then((res) => res.data);
};

interface RegisterWithCodeReq {
  share_code: number;
}

interface RegisterWithCodeRes extends commomRes {
  data: {
    has_record_share: boolean;
  };
}
export const registerWithCode = async (params: RegisterWithCodeReq) => {
  const url = "api/flow/Wand-20230508085747-Fdf09dceffb16";
  return request
    .post<RegisterWithCodeRes>(`${origin}${url}`, params)
    .then((res) => res.data);
};
